import React from 'react'
import s from './ModeSelector.less'
import classnames from 'classnames'
import ResponsiveScrollList from '../genericComponents/ResponsiveScrollList'

const ModeSelector = ({ modes, renderMode, className }) => (
  <div className={classnames(s.container, className)}>
    <ResponsiveScrollList
      data={modes}
      render={renderMode}
      listClassName={s.list}
      listItemClassName={s.listItem}
      arrowClassName={s.arrow}
      arrowLeftClassName={s.arrowLeft}
      arrowRightClassName={s.arrowRight}
    />
  </div>
)

export default ModeSelector
